import React, { useContext } from "react";
import * as FaIcons from "react-icons/fa";

import InterestContext from "../../context/interest/interestContext";
import RegistrationContext from "../../context/registration/registrationContext";

const LocationMarker = ({
  lat,
  lng,
  site: {
    id,
    name,
    charter,
    coordinates,
    address: { state, address_1, city, zip },
  },
}) => {
  const interestContext = useContext(InterestContext);
  const {
    setLearningCenter,
    learningCenterCoordinates,
    formData: { learningCenterName },
  } = interestContext;
  const registrationContext = useContext(RegistrationContext);
  return (
    <div
      className="location-marker"
      onClick={() => {
        setLearningCenter({
          name,
          charter,
          coordinates,
          address: `${address_1}, ${city}, ${state}, ${zip}`,
        });
        registrationContext.setLearningCenter({
          name,
          charter,
          coordinates,
          address: `${address_1}, ${city}, ${state}, ${zip}`,
        });
      }}
    >
      <FaIcons.FaMapPin
        className="school-marker"
        onClick={() => {
          document
            .getElementById(`site-${id}`)
            .scrollIntoView({ behavior: "smooth" });
        }}
        style={{
          color:
            coordinates === learningCenterCoordinates ? "#d8302f" : "#343434",
        }}
      />
    </div>
  );
};

export default LocationMarker;
